import { useLoaderData, useLocation } from "react-router";
import { useSyncVideoData } from "../hooks/useSyncVideoData";
import { useSyncAudioData } from "../hooks/useSyncAudioData";
import { useStateSync } from "../hooks/useStateSync";
import InteractiveMenu from "./interactives/InteractiveMenu";
import { SceneComponent } from "../../config/interactive/types";
import { SceneAudioConfig } from "../../config/audio/types";
import { useRemoteNavigation } from "../contexts/RemoteNavigationContext";
import { useGlobalEntityState } from "../contexts/GlobalStateContext";
import { useState, useCallback } from "react";
import { eventSceneVisible } from "../utils/gtag";

export default function Scene() {
	const { focusedId } = useRemoteNavigation();
	const { GlobalEntityState } = useGlobalEntityState();
	const location = useLocation();
	const {
		background: initialBackground,
		sceneInteractives,
		audio: initialAudio,
		sceneName: initialSceneName,
		everything,
	}: {
		background: {
			data: unknown; // TODO: unsafe, should be unknown with proper error handling
			contentType: string;
			navigateAfter?: string;
			src: string;
		};
		sceneName: string;
		sceneInteractives: SceneComponent[];
		audio: SceneAudioConfig;
		everything: any;
	} = useLoaderData();

	const [currentBackground, setCurrentBackground] = useState(initialBackground);
	const [currentAudio, setCurrentAudio] = useState(initialAudio);

	const handleVideoDataReady = useCallback(
		(newData: {
			background: {
				data: ArrayBuffer;
				contentType: string;
				src: string;
				navigateAfter?: string;
			};
		}) => {
			setCurrentBackground(newData.background);

			eventSceneVisible(window.startSceneLoad, location.pathname);
			window.startSceneView = Date.now();
		},
		[],
	);

	const handleAudioDataReady = useCallback((newAudio: SceneAudioConfig) => {
		setCurrentAudio(newAudio);
	}, []);

	useStateSync({
		GlobalEntityState,
		originalSceneConfig: everything,
		sceneName: location.pathname, // Use the current path as unique scene identifier
		onVideoDataReady: handleVideoDataReady,
		onAudioDataReady: handleAudioDataReady,
	});

	useSyncVideoData(
		currentBackground.data as ArrayBuffer,
		currentBackground.contentType,
		initialSceneName,
		currentBackground.navigateAfter,
	);

	useSyncAudioData(currentAudio);

	return (
		<>
			<InteractiveMenu sceneInteractives={sceneInteractives} focusedId={focusedId} />
		</>
	);
}
